import { useEffect, useState } from 'react';

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

/**
 * Set specified query parameters in session storage and return values from current session
 * @param {string[]} relevantKeys
 * @returns {object}
 */
export const useQueryParamsInSession = ([...relevantKeys]) => {
    const [params, setParams] = useState(null);

    useEffect(() => {
        // Parse querystring
        const querystring = new URL(window.location.toString()).searchParams;

        if (querystring && window.sessionStorage) {
            // Set new query parameters in session storage
            for (const [key, val] of querystring.entries()) {
                relevantKeys.map((rK) => {
                    if (key === rK) {
                        window.sessionStorage.setItem(key, val);
                    }
                });
            }

            // Read stored values
            let _params = {};
            relevantKeys.forEach((key) => {
                const value = window.sessionStorage.getItem(key);
                if (value) { _params[key] = value; }
            });
            setParams(_params);
        }
    }, []);

    return params;
};
